import { render, staticRenderFns } from "./layananKeagamaan.vue?vue&type=template&id=3fd74add&"
import script from "./layananKeagamaan.vue?vue&type=script&lang=js&"
export * from "./layananKeagamaan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard,QCardSection,QBtn,QTooltip,QSeparator} from 'quasar'
component.options.components = Object.assign({QCard,QCardSection,QBtn,QTooltip,QSeparator}, component.options.components || {})
